import { render } from "./WCShoppingCartButton.vue?vue&type=template&id=09437757&scoped=true"
import script from "./WCShoppingCartButton.vue?vue&type=script&lang=js"
export * from "./WCShoppingCartButton.vue?vue&type=script&lang=js"

import "./WCShoppingCartButton.vue?vue&type=style&index=0&id=09437757&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09437757"]])

export default __exports__